import React from "react";
import { Container } from "react-bootstrap";

export const MainBannerRent = () => {
  return (
    <Container fluid className="bgRC">
      <Container>
        <div className="webkit ser">
          <h2 className="text-white font-extrabold">
            Rent A Car, Rent Your Freedom
          </h2>
          <p className="text-white font-extrabold">
            Do you need a car with a Personal driver for the entire duration of
            your stay in Pakistan?
          </p>
          <div className="webkit">
            <button className="px-5 py-3 mt-4 rounded-xl text-white bgGreen">
              Book Now
            </button>
          </div>
        </div>
      </Container>
    </Container>
  );
};
